// extracted by mini-css-extract-plugin
module.exports = {"StatefulBtn":"styles_StatefulBtn__3ZOEF","Contents":"styles_Contents__1DKyV","isLoading":"styles_isLoading__1B1XA"};